// import gsap from 'gsap'
import './priceTableFamily.css'
import { bp, mm, onDomReady, sel, selAll, stResizeObserver } from '../utils'
// import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)
export default function PriceTable() {
  const tableW$ = sel('.price-table-w.is--family')

  if (!tableW$) return
  console.log('table$ family', tableW$)

  // Table Tabs
  // window.addEventListener('load', function () {
  setTimeout(function () {
    // return
    // console.log('priceTable.js loaded')
    //
    const initPlan = tableW$.getAttribute('data-wf--price-table--variant') || 'apex'
    // console.log('initPlan', initPlan)

    const tableCoreVariant = 'w-variant-c8859ff5-c597-aa2d-97f6-59f00768b768'
    const tableApexVariant = 'w-variant-69ecb1bc-b68c-f2e9-c478-f1da121db5e1'
    const tableEpicVariant = 'w-variant-a7cf462b-1df3-77bc-708c-898985446a92'

    const headerCoreVariant = 'w-variant-5b146329-b564-3cc4-693d-965ec61bce42'
    const headerApexVariant = 'w-variant-52fdd623-29ec-b8a8-aa5e-fd4e99f7f3e2'
    const headerEpicVariant = 'w-variant-89a01dda-5fb5-83fa-306c-ac5e757577f0'

    const dataCoreVariant = 'w-variant-54800915-d893-0cfb-0438-0aeef23b9abe'
    const dataApexVariant = 'w-variant-ea03cc85-eb2c-240e-c365-90f73cc91be1'
    const dataEpicVariant = 'w-variant-aec6b67c-00db-161f-4569-16ca419e9966'

    const footerCoreVariant = 'w-variant-15871685-808a-93d3-0113-5d63ef1bb85f'
    const footerApexVariant = 'w-variant-3f1353ac-abf4-17cd-237d-59603c96e86a'
    const footerEpicVariant = 'w-variant-14998586-e9cf-db32-a3a4-ae6cce6383f6'

    const header$a = selAll('.price-table__col.is--header')
    const col2to4$a = selAll('.price-table__col:not(.is--1)')
    const footer$a = selAll('.price-table__col.is--footer')

    const col1Cell$a = selAll('.price-table__row > :nth-child(4n + 1)')
    const col2Cell$a = selAll(':is(.price-table__row, .price-table__dd__h, .price-table__dd__p) > :nth-child(4n + 2)')
    const col3Cell$a = selAll(':is(.price-table__row, .price-table__dd__h, .price-table__dd__p) > :nth-child(4n + 3)')
    const col4Cell$a = selAll(':is(.price-table__row, .price-table__dd__h, .price-table__dd__p) > :nth-child(4n + 4)')

    const col2DataCell$a = selAll('.price-table__row > :nth-child(4n + 2).is--data')
    const col3DataCell$a = selAll('.price-table__row > :nth-child(4n + 3).is--data')
    const col4DataCell$a = selAll('.price-table__row > :nth-child(4n + 4).is--data')

    const col2Dd1H$a = selAll('.price-table__dd__h > :nth-child(4n + 2) .price-table__col.is--data')
    const col3Dd1H$a = selAll('.price-table__dd__h > :nth-child(4n + 3) .price-table__col.is--data')
    const col4Dd1H$a = selAll('.price-table__dd__h > :nth-child(4n + 4) .price-table__col.is--data')

    const col2Dd1P$a = selAll('.price-table__dd__p > :nth-child(4n + 2).price-table__col.is--data')
    const col3Dd1P$a = selAll('.price-table__dd__p > :nth-child(4n + 3).price-table__col.is--data')
    const col4Dd1P$a = selAll('.price-table__dd__p > :nth-child(4n + 4).price-table__col.is--data')
    // console.log('col2Data', col2to4$a)

    function removeVariantClasses() {
      const targets = [
        tableW$,
        ...header$a,
        ...col2DataCell$a,
        ...col2Dd1H$a,
        ...col2Dd1P$a,
        ...col3DataCell$a,
        ...col3Dd1H$a,
        ...col3Dd1P$a,
        ...col4DataCell$a,
        ...col4Dd1H$a,
        ...col4Dd1P$a,
        ...footer$a,
      ]
      targets.forEach((el) => {
        ;[...el.classList].forEach((cls) => {
          if (cls.startsWith('w-variant')) el.classList.remove(cls)
        })
      })
    }
    // console.log('tt', col2Dd1P$a)
    function addVariantClasses(col = 4) {
      switch (col) {
        case 2:
          tableW$.classList.add(tableCoreVariant)
          header$a[0].classList.add(headerApexVariant)
          ;[...col2DataCell$a, ...col2Dd1H$a, ...col2Dd1P$a].forEach((cell) => cell.classList.add(dataApexVariant))
          footer$a[0].classList.add(footerApexVariant)
          break
        case 3:
          tableW$.classList.add(tableApexVariant)
          header$a[1].classList.add(headerApexVariant)
          ;[...col3DataCell$a, ...col3Dd1H$a, ...col3Dd1P$a].forEach((cell) => cell.classList.add(dataApexVariant))
          footer$a[1].classList.add(footerApexVariant)

          break
        case 4:
          tableW$.classList.add(tableEpicVariant)
          header$a[2].classList.add(headerEpicVariant)
          ;[...col4DataCell$a, ...col4Dd1H$a, ...col4Dd1P$a].forEach((cell) => cell.classList.add(dataEpicVariant))
          footer$a[2].classList.add(footerEpicVariant)
          break
      }
    }

    // console.log('Class attribute changed:', classList)
    // Determine currently applied table variant (if any)
    // const activeVariant = Array.from(table$.classList).find((c) => c.startsWith('w-variant-')) || tableApexVariant
    // const activeVariant = Array.from(tableW$.classList).find((c) => c.startsWith('w-variant'))
    // console.log('activeVariant', activeVariant)

    // Always normalize classes based on the detected/default variant
    removeVariantClasses()
    if (initPlan === 'core') addVariantClasses(3)
    else if (initPlan === 'apex') addVariantClasses(3)
    else addVariantClasses(4)

    mm.add(bp.deskUp, () => {
      ;[col2Cell$a, col3Cell$a, col4Cell$a].forEach((col, i) => {
        // console.log('col hover', col)
        const index = i + 2
        col.forEach((cell) => {
          cell.addEventListener('mouseenter', function () {
            // console.log('yo', i)
            removeVariantClasses()
            addVariantClasses(index)
          })
        })
      })
    })
    mm.add(bp.tabDown, () => {
      // Table
      header$a.forEach((tab$) => {
        // const tabColClass = tab$.dataset.col
        // console.log('tabColClass', tabColClass)

        tab$.addEventListener('click', function () {
          // console.log('tabColClass', tab$)
          header$a.forEach((tab$) => {
            if (this === tab$) return

            const colNum = [...this.parentElement.children].indexOf(this)
            // console.log('colNum', colNum)
            removeVariantClasses()
            addVariantClasses(colNum + 1)
          })
        })

        // if (tab$.classList.contains('is--active')) tab$.click()
      })
    })

    // return
    // this.setTimeout(() => {
    // 1st level dropdowns
    const table$ = sel('.price-table')
    const row$a = selAll('.price-table__row-w')
    // const row$a = table$.querySelectorAll(':scope > .price-table__row-w')
    // console.log(row$a[0])
    row$a.forEach((row$) => {
      const header1$ = row$.sel(':scope > div:first-child')
      const dd1levelW$ = row$.sel(':scope > div:last-child')
      const icon = row$.sel('.svg')
      const iconO = icon.sel('.dd-plus-svg__o')
      const iconH = icon.sel('.dd-plus-svg__h')
      const iconV = icon.sel('.dd-plus-svg__v')
      // Helper to compute the target open height based on visible dd2 state
      const getDd1OpenHeight = () => {
        let total = 0
        const dd2level$a = dd1levelW$.selAll(':scope > div')
        dd2level$a.forEach((dd2level$) => {
          const dd2header$ = dd2level$.sel(':scope > div:first-child')
          const dd2content$ = dd2level$.sel(':scope > div:last-child')
          total += (dd2header$?.offsetHeight || 0) + (dd2content$?.offsetHeight || 0)
        })
        return total
      }

      // Separate icon timeline so reverse is reliable
      const dd1IconTl = gsap
        .timeline({ defaults: { ease: 'power4.inOut', duration: 1 }, paused: true })
        .to(icon, { rotate: 90 })
        .to(iconO, { fill: 'rgba(255, 255, 255, 1)' }, 0)
        .to(iconH, { autoAlpha: 0 }, 0)
        .to(iconV, { stroke: 'rgba(0,0,0,1)' }, 0)
      dd1IconTl.progress(0).reverse()

      // Initialize closed by default
      gsap.set(dd1levelW$, { height: 0, autoAlpha: 0 })

      // Track open/closed state per row
      let dd1IsOpen = false

      header1$.addEventListener('click', function () {
        this.classList.toggle('is--open')
        // Stop any in-flight height tween on this container
        gsap.killTweensOf(dd1levelW$)

        if (!dd1IsOpen) {
          // OPEN: from 0 to computed content height
          dd1IconTl.play()
          gsap.set(dd1levelW$, { height: 0, autoAlpha: 0 })
          gsap.to(dd1levelW$, {
            height: getDd1OpenHeight(),
            autoAlpha: 1,
            duration: 1,
            ease: 'power4.inOut',
            onComplete: () => gsap.set(dd1levelW$, { height: 'auto' }),
          })
          dd1IsOpen = true
        } else {
          // CLOSE: from current actual height to 0 (accounts for any open dd2)
          dd1IconTl.reverse()
          gsap.fromTo(
            dd1levelW$,
            { height: dd1levelW$.offsetHeight },
            {
              height: 0,
              autoAlpha: 0,
              duration: 1,
              ease: 'power4.inOut',
            }
          )
          dd1IsOpen = false
        }
      })

      // 2nd level dropdowns
      const dd2level$a = dd1levelW$.selAll(':scope > div')
      dd2level$a.forEach((dd2level$) => {
        const dd2header$ = dd2level$.sel(':scope > div:first-child')
        const dd2content$ = dd2level$.sel(':scope > div:last-child')
        const arrow = dd2level$.sel('.svg')

        const dd2levelTl = gsap
          .timeline({ defaults: { ease: 'power4.inOut', duration: 1 }, paused: true })
          //
          .from(dd2content$, {
            height: 0,
            autoAlpha: 0,
          })
          .to(
            arrow,
            {
              rotate: 180,
            },
            0
          )
        dd2levelTl.progress(0).reverse()
        dd2header$.addEventListener('click', function () {
          // When toggling a dd2, if parent dd1 is open with height:auto, temporarily lock its height
          const wasAuto = getComputedStyle(dd1levelW$).height === 'auto'
          if (wasAuto) gsap.set(dd1levelW$, { height: dd1levelW$.offsetHeight })

          if (dd2levelTl.reversed()) {
            dd2levelTl.play()
          } else {
            dd2levelTl.reverse()
          }

          this.classList.toggle('is--open')

          // After dd2 animation completes, release parent back to auto so layout stays fluid
          dd2levelTl.eventCallback('onComplete', () => {
            if (getComputedStyle(dd1levelW$).height !== 'auto') {
              gsap.set(dd1levelW$, { height: 'auto' })
            }
          })
          dd2levelTl.eventCallback('onReverseComplete', () => {
            if (getComputedStyle(dd1levelW$).height !== 'auto') {
              gsap.set(dd1levelW$, { height: 'auto' })
            }
          })
          // console.log('click', dd2levelTl.reversed())
        })
        // console.log(header1$, dd1levelW$, dd2level$a)
      })
    })
    // }, 100)

    // Desk Animation
    mm.add(bp.tabUp, () => {
      const header$ = sel('.price-table__row.is--header')
      const row$a = selAll('.price-table__row-w')
      const footer$ = sel('.price-table__row.is--footer')

      const rowTw = {
        // x: 10,
        autoAlpha: 0,
        stagger: 0.125,
        ease: 'power1.out',
      }
      const tableTl = gsap.timeline({ defaults: { ease: 'none', duration: 1 } }).from([header$, ...row$a, footer$], rowTw, 0)
      // .from(col1Cell$a, rowTw, 0)
      // .from(col2Cell$a, rowTw, 0)
      // .from(col3Cell$a, rowTw, 0)
      // .from(col4Cell$a, rowTw, 0)

      ScrollTrigger.create({
        trigger: tableW$,
        start: 'top 80%',
        toggleActions: 'play none none reverse',
        // markers: true,
        animation: tableTl,
      })
    })
  }, 1000)
  // stResizeObserver()
}
